import client from './client';

export const authApi = {
  login: (credentials) => client.post('/auth/login', credentials),
  logout: () => client.post('/auth/logout'),
  me: () => client.get('/auth/me'),
  seed: () => client.post('/auth/seed'),
  forgotPassword: (email) => client.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => client.post('/auth/reset-password', { token, password }),
  validateResetToken: (token) => client.get(`/auth/validate-reset-token/${token}`)
};
